export const UNDO_REDO = {
  undo: ['ControlLeft+KeyZ', 'ControlLeft+ShiftLeft+KeyZ'],
  redo: ['ControlLeft+KeyY', 'ControlLeft+ShiftLeft+KeyY']
}

export const NEXT_PREVIOUS = {
  next: 'ArrowRight',
  previous: 'ArrowLeft'
}

export const BACK = {
  back: 'Escape'
}

export const CREATE_NEW = {
  createNew: 'KeyN'
}

export const ENTER_ESCAPE = {
  enter: ['Enter', 'NumpadEnter'],
  escape: 'Escape'
}

export const MAP_INTERACTIONS = {
  ...UNDO_REDO,
  copy: 'KeyD',
  delete: 'Delete',
  // modify: 'ControlLeft+KeyM',
  escape: 'Escape',
  selectAll: 'ControlLeft+KeyA',
  onArrow: 'KeyV',
  onGraph: 'KeyG',
  onSite: 'KeyS',
  onCircle: 'KeyC',
  onR: 'KeyR',
  openGeocoder: 'KeyF',
  onPolygon: 'KeyP',
  set2D: 'Digit1',
  set3D: 'Digit2',
  openLength: 'KeyL'
}

export const MAP_HOT_KEYS = {
  Tools: [
    { description: 'Graph', hotKey: 'G' },
    { description: 'Graph Site', hotKey: 'S' },
    { description: 'Select', hotKey: 'V' },
    { description: 'Circle', hotKey: 'C' },
    { description: 'Rectangle', hotKey: 'R' },
    { description: 'Polygon', hotKey: 'P' },
    { description: 'Site', hotKey: 'S' }
  ],
  General: [
    { description: 'Duplicate', hotKey: 'D' },
    { description: 'Select multiple items', hotKey: 'Shift+Click' },
    { description: 'Select all', hotKey: 'Ctrl+A' },
    { description: 'Delete', hotKey: 'Delete/Backspace' },
    { description: 'Undo', hotKey: 'Ctrl+Z' },
    { description: 'Redo', hotKey: 'Ctrl+Y' },
    { description: 'Search', hotKey: 'F' }
  ],
  '3D Navigation': [
    { description: 'Pith Up, Down', hotKey: 'Shift + ←,→' },
    { description: 'Rotate Left, Right', hotKey: 'Shift + ↑, ↓' },
    { description: 'Ordit', hotKey: 'Right mouse click' },
    { description: 'Zoom', hotKey: 'Scrolling / +,-' },
    { description: '3D view', hotKey: '2' }
  ],
  '2D Navigation': [
    { description: 'Zoom', hotKey: 'Scrolling/+,-' },
    { description: '2D view', hotKey: '1' }
  ]
}

export const MODEL_HOT_KEYS = {
  General: [
    { description: 'Orbit', hotKey: 'Left mouse button' },
    { description: 'Pan', hotKey: 'Right mouse button drag' },
    { description: 'Zoom', hotKey: 'Middle mouse button scroll' },
    { description: 'Move Forward', hotKey: 'W' },
    { description: 'Move Backward', hotKey: 'S' },
    { description: 'Move Left', hotKey: 'A' },
    { description: 'Move Right', hotKey: 'D' },
    { description: 'Move Up', hotKey: 'E' },
    { description: 'Move Down', hotKey: 'Q' },
    { description: 'Focus', hotKey: 'F / Double click' },
    { description: 'Perspective/Parallel', hotKey: 'P / Numpad5' },
    { description: 'Isolate', hotKey: 'I' },
    { description: 'Clipbox', hotKey: 'C' },
    { description: 'Move Speed Up', hotKey: 'Shift' },
    { description: 'Show all', hotKey: 'Ctrl+H' },
    { description: 'Front', hotKey: '1' },
    { description: 'Back', hotKey: 'Ctrl+1' },
    { description: 'Top', hotKey: '2' },
    { description: 'Bottom', hotKey: 'Ctrl+2' },
    { description: 'Right', hotKey: '3' },
    { description: 'Left', hotKey: 'Ctrl+3' },
    { description: 'Teleport', hotKey: 'Space' },
    { description: 'Rect-select', hotKey: 'Ctrl+Drag' },
    { description: 'Rect-deselect', hotKey: 'Shift+Drag' },
    { description: 'Select multiple items', hotKey: 'Ctrl+Click' },
    { description: 'Deselect', hotKey: 'Esc' }
  ]
}
